<template>
  <div>
    <span
      v-if="hasError && error"
      class="badge-error"
      variant="none"
      :id="`${name}-error`"
    >
      <small>{{ error }}</small>
    </span>
    <div class="input" width="100%">
      <label :for="name">{{ label }}</label>
      <treeselect
        style="margin-top: 2px; color: #555"
        :always-open="true"
        :id="name"
        :name="name"
        :placeholder="tooltip"
        v-model="selectedValues"
        :multiple="true"
        :options="options"
        :clearable="true"
        :clearAllText="`Limpiar todo`"
        :searchable="true"
        :disable-branch-nodes="true"
        :limit="2"
        :limitText="getLimitText"
        :noChildrenText="$t('components.noChildrenText')"
        v-bind:noResultsText="$t('components.noResultsText')"
        :loadingText="$t('components.loadingText')"
        :defaultExpandLevel="Infinity"
        :maxHeight="290"
        :alwaysOpen="true"
        :showCount="true"
        @change="$emit('input', $event.target.selectedValues)"
      />
    </div>
  </div>
</template>
  
  <script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {
    id: {
      type: [String, Number],
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    // options: null,
    options: {
      type: Array,
      required: true,
      validator(opts) {
        return (
          opts.find((opt) => {
            return !("label" in opt) || !("id" in opt);
          }) === undefined
        );
      },
    },
    hasError: { type: Boolean, default: false },
    error: { type: String, required: false },
  },
  data() {
    return {
      selectedValues: [],
    };
  },
  watch: {
    selectedValues() {
      this.$emit("input", this.selectedValues);
    },
  },
  methods: {
    getLimitText(count) {
      return this.$t("components.limitText", { count });
    },
  },
};
</script>
  
<style scoped>
select {
  /* display: block; */
  width: 100%;
  /* padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem; */
  margin: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
select {
  text-align: center;
  border-radius: 25px;
  height: 55px;
  line-height: 1.15;
  font-size: 16px;
  border: none;
  padding: 0 15px;
  color: #696a87;
  background: #f8f8f8;
  width: 106%;
  margin: 0 0 0 10px;
}
@media screen and (max-width: 479px) {
  select {
    width: 85%;
  }
}
select.error {
  border-color: #721c24;
}
p.error {
  color: #721c24;
}
select.green {
  border-color: green;
  border-width: 2px;
}
</style>
  